// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".summary-mobile{position:relative}.summary-mobile__loader{z-index:2}.summary-mobile__summary{background-color:#f2f9fa;padding:16px}.summary-mobile__promo{padding:24px 16px 12px}.summary-mobile__promo._show-mnogo-ru{padding-bottom:0}.summary-mobile__bonus-pay{font-size:14px;line-height:24px;padding:8px 16px 4px}", ""]);
// Exports
module.exports = exports;
